import axios from "axios";
import { getToken, getTokenHeader } from "../../../../../screen/auth/action";
import { loginUrl } from "../urls";
import { deleteRegisterNotificationToken } from "../../../../../screen/distributor/action/util_action";
import { logoutAction } from "../../../../../screen/auth/action";

export const LoginAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken(); 
    await axios
      .post(
        `${loginUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      }) 
      .catch((err) => {
        return next({ error: true, message: err.response?.data?.message || err.message });
      });
  });
};

export const logoutUser = () => async (dispatch)  =>{
  const userToken = JSON.parse(localStorage.getItem('message_token'));
      await deleteRegisterNotificationToken(userToken);
      await logoutAction();
      localStorage.clear();
      dispatch({ type: 'LOGOUT' });
}